import React from "react";
import styled from "@emotion/styled";

const UpToSpan = styled.span`
  width: 140px;
  height: 36px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

const PercentSpan = styled.span`
  color: ${props => props.innerSpancolor};
`;

const SoldOutSpan = styled.span`
  color: rgba(119, 121, 132, 0.3);
`;

const StyledPercent = ({
  percentOff,
  styles,
  innerSpancolor,
  soldOut = false,
  classNames = ""
}) => (
  <UpToSpan style={styles} className={classNames}>
    {!soldOut ? (
      <>
        Up to
        <PercentSpan innerSpancolor={innerSpancolor}>
          &nbsp;{percentOff}%&nbsp;
        </PercentSpan>
        off
      </>
    ) : (
      <SoldOutSpan>Sold out </SoldOutSpan>
    )}
  </UpToSpan>
);

export default StyledPercent;
